export default __webpack_public_path__ + "static/media/penhole.47fe4a9f.jpg";